var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.25549 14.9999C5.97071 14.9999 5.70381 14.8915 5.50801 14.6926L0.845121 9.81089C0.400189 9.39508 0.382424 8.68994 0.809492 8.23793C1.2188 7.78592 1.91289 7.76787 2.35782 8.20174L5.7749 10.6787C5.97067 10.8596 6.27322 10.8234 6.43337 10.6064L14.5311 0.445284C14.887 -0.0429183 15.5811 -0.151368 16.0617 0.228358C16.5422 0.589933 16.649 1.29507 16.2752 1.78327L7.12742 14.548C6.93164 14.8011 6.64686 14.9638 6.34431 14.982C6.3088 15 6.29093 15 6.25542 15L6.25549 14.9999Z",
    fill: "#518A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e6f3370fd958ddec8c7e20854d190624.svg";
export { ForwardRef as ReactComponent };